module.exports = __webpack_public_path__ + "models/tutor1.c2f111b.txt";